import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IMe} from './getUserProfile'

export const apiFetchMe = async (): Promise<ApiRes<IMe>> => {
    return await apiGet(API_URL, 'me')
}
